import axios from 'axios'
import { RouteAlternative } from '@/components/LeafletRouteMap'

export type { RouteAlternative }

interface GenerateRoutesRequest {
    origin: {
        lat: number
        lng: number
        city?: string
        state?: string
    }
    destination: {
        lat: number
        lng: number
        city?: string
        state?: string
    }
    maxAlternatives?: number
}

interface GenerateRoutesResponse {
    routes: RouteAlternative[]
    origin: { lat: number; lng: number }
    destination: { lat: number; lng: number }
    generatedAt: string
}

export const generateTollRoutes = async (request: GenerateRoutesRequest): Promise<GenerateRoutesResponse> => {
    const response = await axios.post<{ success: boolean; data: GenerateRoutesResponse }>('/gluon/toll-corridors/generate-routes', request)

    if (response.data.success && response.data.data) {
        return response.data.data
    }

    throw new Error('Invalid response from server')
}
